<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {

    }
  },
  destroyed() {
    // localStorage.removeItem('phone')
    // localStorage.removeItem('token')
    // localStorage.removeItem('userInfo')
    // this.$router.go(0)
  }
}
</script>

<style>
/* html,body,h1,h2,h3,h4,h5,h6,div,dl,dt,dd,ul,ol,li,p,blockquote,pre,hr,figure,table,caption,th,td,form,fieldset,legend,input,button,textarea,menu{margin:0;padding:0;}
header,footer,section,article,aside,nav,hgroup,address,figure,figcaption,menu,details{display:block;}
table{border-collapse:collapse;border-spacing:0;}
caption,th{text-align:left;font-weight:normal;}
html,body,fieldset,img,iframe,abbr{border:0;}
i,cite,em,var,address,dfn{font-style:normal;}
[hidefocus],summary{outline:0;}
li{list-style:none;}
h1,h2,h3,h4,h5,h6,small{font-size:100%;}
sup,sub{font-size:83%;}
pre,code,kbd,samp{font-family:inherit;}
q:before,q:after{content:none;}
textarea{overflow:auto;resize:none;}
label,summary{cursor:default;}
a,button{cursor:pointer;}
h1,h2,h3,h4,h5,h6,em,strong,b{font-weight:bold;}
del,ins,u,s,a,a:hover{text-decoration:none;}
body,textarea,input,button,select,keygen,legend{font:12px/1.14 arial,\5b8b\4f53;color:#333;outline:0;}
body{background:#fff;}
a,a:hover{color:#333;} */

* {
  margin: 0;
  padding: 0;
}
html,body{
  height: 100%;
}
.flexr {
  display: flex;
  flex-direction: row;
}

.flexw {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.hang1 {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.hang2 {
	overflow: hidden;

	text-overflow: ellipsis;

	display: -webkit-box;

	-webkit-box-orient: vertical;

	-webkit-line-clamp: 2;
}
.defultWidth {
  width: 1200px;
  min-width: 1000px;
  max-width: 1400px;
  margin: 0 auto;
}

.display {
  display: flex;
  justify-content: center;
  align-items: center;
}



div::-webkit-scrollbar {
  width: 4px;
}
div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  opacity: 0.2;
  background: fade(@primary-color, 60%);
}
div::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: fade(@primary-color, 30%);
}
</style>



// WEBPACK FOOTER //
// src/App.vue